/**
 * Direction of a brand's recommendation trend across the insights reporting window.
 *
 * The five values map one-to-one onto the five chevron glyphs the What's Hot cards draw. Only `StrongUp` is
 * confirmed against a live payload; the rest are inferred from the design, so `HighGuideTrendingBrand` treats an
 * unrecognized value as `Flat` rather than dropping the card.
 */
export enum HighGuideTrendDirection {
  StrongUp = 'StrongUp',
  Up = 'Up',
  Flat = 'Flat',
  Down = 'Down',
  StrongDown = 'StrongDown'
}
